import { apiClient } from "@/services/HttpService";

export function listProjects(params) {
  return apiClient.post("/project/search", params);
}

export function listUnderConstructionProjects(params) {
  return apiClient.post("/under-construction-projects/search", params);
}

export function listToReviewProjects(params) {
  params.toReview = true;
  return apiClient.post("/project/search", params);
}
export function listRiskReviewProjects(params) {
  params.toRiskReview = true;
  return apiClient.post("/project/search", params);
}

export function auditProject(params) {
  return apiClient.post("/project/audit", params);
}

export function delProject(projectId) {
  return apiClient.delete(`/project/${projectId}`);
}

export function receiveDoc(projectId) {
  return apiClient.post(`/project/confirm-received?projectId=${projectId}`);
}

export function loadProjectStates(projectId) {
  return apiClient.get(`/project/states?projectId=${projectId}`);
}

// 设置批次号
export function setBatchNumber(params) {
  return apiClient.post("/project/batch-number", params);
}

// 批量删除
export function batchDelete(params) {
  return apiClient.post("/project/batch-delete", params);
}